/* ==========================================================================
   ANYSUP — Wishlist + Recently Viewed
   Client-side only (localStorage), works on the live Shopify store.
   ========================================================================== */
(function () {
  'use strict';
  const WISHLIST_KEY = 'anysup_wishlist';
  const RECENT_KEY = 'anysup_recently_viewed';

  function getList(key) {
    try { return JSON.parse(localStorage.getItem(key)) || []; }
    catch (e) { return []; }
  }
  function saveList(key, list) {
    try { localStorage.setItem(key, JSON.stringify(list)); } catch (e) {}
  }

  /* ---------------- Wishlist ---------------- */
  window.AnysupWishlist = {
    toggle(handle) {
      let list = getList(WISHLIST_KEY);
      if (list.includes(handle)) {
        list = list.filter(h => h !== handle);
      } else {
        list.push(handle);
      }
      saveList(WISHLIST_KEY, list);
      this.refreshButtons();
      return list.includes(handle);
    },
    has(handle) {
      return getList(WISHLIST_KEY).includes(handle);
    },
    getAll() {
      return getList(WISHLIST_KEY);
    },
    refreshButtons() {
      document.querySelectorAll('[data-wishlist-toggle]').forEach((btn) => {
        const handle = btn.dataset.wishlistToggle;
        btn.classList.toggle('is-active', this.has(handle));
      });
      const countEls = document.querySelectorAll('[data-wishlist-count]');
      countEls.forEach(el => { el.textContent = getList(WISHLIST_KEY).length; });
    }
  };

  document.addEventListener('click', (e) => {
    const btn = e.target.closest('[data-wishlist-toggle]');
    if (!btn) return;
    e.preventDefault();
    e.stopPropagation();
    window.AnysupWishlist.toggle(btn.dataset.wishlistToggle);
  });

  document.addEventListener('DOMContentLoaded', () => window.AnysupWishlist.refreshButtons());

  /* ---------------- Recently viewed ---------------- */
  const currentHandle = document.body.dataset.productHandle;
  if (currentHandle) {
    let recent = getList(RECENT_KEY).filter(h => h !== currentHandle);
    recent.unshift(currentHandle);
    recent = recent.slice(0, 8);
    saveList(RECENT_KEY, recent);
  }

  window.AnysupRecentlyViewed = {
    async render(targetSelector, excludeHandle) {
      const target = document.querySelector(targetSelector);
      if (!target) return;
      let handles = getList(RECENT_KEY);
      if (excludeHandle) handles = handles.filter(h => h !== excludeHandle);
      if (handles.length === 0) { target.closest('[data-recently-viewed-wrap]').style.display = 'none'; return; }

      const products = await Promise.all(
        handles.slice(0, 4).map(h => fetch(`/products/${h}.js`).then(r => r.ok ? r.json() : null).catch(() => null))
      );
      const valid = products.filter(Boolean);
      if (valid.length === 0) { target.closest('[data-recently-viewed-wrap]').style.display = 'none'; return; }

      target.innerHTML = valid.map(p => `
        <a href="${p.url}" class="product-card">
          <div class="product-card__media" data-ratio="${window.anysupSettings ? window.anysupSettings.imageRatio : 'portrait'}">
            <img src="${p.featured_image}" alt="${p.title}" loading="lazy">
          </div>
          <div class="product-card__info">
            <div class="product-card__title">${p.title}</div>
            <div class="price">${(p.price / 100).toLocaleString('en-PK', { style: 'currency', currency: 'PKR', minimumFractionDigits: 0 })}</div>
          </div>
        </a>
      `).join('');
    }
  };

  /* ---------------- Related products (Shopify recommendations API) ---------------- */
  window.AnysupRelated = {
    async render(targetSelector, productId, limit) {
      const target = document.querySelector(targetSelector);
      if (!target) return;
      try {
        const res = await fetch(`/recommendations/products.json?product_id=${productId}&limit=${limit || 4}`);
        const data = await res.json();
        if (!data.products || data.products.length === 0) {
          target.closest('[data-related-wrap]').style.display = 'none';
          return;
        }
        target.innerHTML = data.products.map(p => `
          <a href="${p.url}" class="product-card">
            <div class="product-card__media" data-ratio="${window.anysupSettings ? window.anysupSettings.imageRatio : 'portrait'}">
              <img src="${p.featured_image}" alt="${p.title}" loading="lazy">
            </div>
            <div class="product-card__info">
              <div class="product-card__title">${p.title}</div>
              <div class="price">${(p.price / 100).toLocaleString('en-PK', { style: 'currency', currency: 'PKR', minimumFractionDigits: 0 })}</div>
            </div>
          </a>
        `).join('');
      } catch (err) {
        target.closest('[data-related-wrap]').style.display = 'none';
      }
    }
  };
})();
